'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4 4.79 2.033A3 3 0 0 0 1 4.928v12.78a3 3 0 0 0 2.21 2.895L12 23m0-19 7.21-1.967A3 3 0 0 1 23 4.928v12.78a3 3 0 0 1-2.21 2.895L12 23m0-19v19" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={2} d="m4 6 5 1.5M4 11l5 1.5M4 16l5 1.5M15 17.5l5-1.5M15 12.5l5-1.5M15 7.5 20 6" /></svg>;
const IconStory = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconStory;